export default __webpack_public_path__ + "static/person-2971251d11b4d08a046f5b5256ede59d.png";